import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import { commonResourceStyle } from '../../css/style';
import VersionAndBuildNumber from '../share/VersionAndBuildNumber';
import { getAdmin } from '../../selectors';
import { checkIsLocationAdmin } from '../../utils/AuthorizationChecks';
import * as utilFunctions from '../../utils/Functions';

const styles = commonResourceStyle();

const Unauthorized = (props) => {
  const isLocationAdmin = checkIsLocationAdmin(props.admin);
  const resource = props.location.state.from.resource;
  const resourceName = utilFunctions.capitalizeTheFirstLetterOfEachWord(resource);

  return (
    <React.Fragment>
      <div style={styles.container}>
        <div style={styles.resourceHeader}>
          <div style={styles.resourceName}>
            <Typography style={styles.resourceName}>{resourceName}</Typography>
          </div>
        </div>
        <Paper style={styles.paper}>
          <div style={styles.paperInnerContainer}>
            <Typography style={styles.unauthorizedMessage}>
              You are not subscribed to access this section.
            </Typography>
            <Typography style={styles.unauthorizedMessage}>
              {'Please upgrade your subscription.'}
              {isLocationAdmin && 'It could affect other locations.'}
            </Typography>
            <Typography style={styles.moreInfoText}>
              For more information, please reach out to sales@craverapp.com.
            </Typography>
          </div>
        </Paper>
      </div>
      <VersionAndBuildNumber />
    </React.Fragment>
  );
};

const mapStateToProps = (state, props) => ({
  admin: getAdmin(state),
});

export default connect(mapStateToProps)(Unauthorized);
